<template>
  <div
    :class="{'mb-2': section.sectionNum !== numSections,
             'text--disabled': !section.isActive && !showIndicator,
             'error--text': section.hasError || showTrigger,
             'secondary--text': section.hasTrigger && !section.showTrigger,
             'active--item': section.isActive }"
    class="document-toc__item"
  >
    <div
      class="document-toc__indicator"
      :class="{'vis-hidden': !showIndicator}"
    >
      {{ section.hasError ? '!' : (showTrigger ? 'T' : '') }}
    </div>

    <a
      :href="`#${ !section.isActive && !showIndicator ? '' : _.kebabCase(section.stepId)}`"
      class="document-toc__link d-block"
      @click.stop.prevent="$emit('click', section.sectionNum)"
      v-text="section.sectionHeading"
    />
  </div>
</template>

<script>

import kebabCase from 'lodash/kebabCase'
const _ = { kebabCase }

export default {
  name: 'DocumentTocItem',
  props: {
    section: { type: Object, default: () => ({}) },
    numSections: { type: Number, default: 1 },
    seesTriggers: { type: Boolean, default: false }
  },
  computed: {
    showIndicator() {
      /* const notActiveWithError = !this.section.isActive && this.section.hasError */
      const hasError = this.section.hasError
      const incomplete = !this.section.complete
      const hasTrigger = this.section.hasTrigger
      return hasError || incomplete || hasTrigger
    },
    showTrigger() {
      return this.section.hasTrigger && this.seesTriggers
    }
  },
  beforeCreate() {
    this._ = _
  }
}
</script>

<style lang="scss">

.document-toc__item {
  display: flex;
  flex-direction: row;
  align-items: center;
  font-weight: 400;
  transition: color 0.25s ease-in;
  border-radius: 3px;
}

li {
  .document-toc__item {
    font-size: 0.875rem;
    border-left: 4px solid var(--v-darkgray-base);
  }

  .active--item {
    background-color: #f0f0f0;
    border-left-color: var(--v-accent-base);
    font-weight: 600;
  }

  .text--disabled {
    border: none;

    .document-toc__link {
      color: var(--v-darkgray-base)
    }
  }

  .document-toc__link {
    font-size: 1.2em;
    color: var(--v-darkbg-base);
    text-decoration: none;
    padding: 10px 5px;
    order: 2;
  }
}

.document-toc__indicator {
  margin-left: 5px;
  font-size: 1.5em;
  font-weight: bold;
  text-align: center;
}

.document-header {
  .document-toc__link {
    margin-left: 2px;
  }

  .document-toc__indicator {
    order: 3;
    margin-left: 8px;
  }
}
</style>
